import BaseNormalizer from "./BaseNormalizer";

const orderChannelableNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "contactPerson",
  "createdAt",
  "furtherInformation",
  "orderMethod",
  "orderDate",
]);

export default orderChannelableNormalizer;
